import { libMisc } from "./misc";

export class MinWait {
    private startTimestamp: number;

    constructor(private ms: number) {
        this.startTimestamp = Date.now();
    }

    async wait() {
        const waitForMs = Math.max(0, this.ms - (Date.now() - this.startTimestamp));
        if (waitForMs > 0) {
            await libMisc.wait(waitForMs);
        }
    }
}